import { useEffect, useState } from 'react'

/*
  Home page animation sequence (matches Figma prototype + reference video):
  1. Page loads, hero bg visible immediately
  2. Sidebar text reveals bottom-to-top (handled in Header, starts at 600ms)
  3. Hero text fades in left-to-right (starts at 1200ms, after sidebar finishes)
  Duration: 1s ease-out for smooth feel

  Styling lives in src/styles/pages/home.css.
*/

export default function Home() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Content fades in after sidebar animation completes
    const timer = setTimeout(() => setVisible(true), 1200)
    return () => clearTimeout(timer)
  }, [])

  return (
    /* Outer wrapper clips the hero so the grey box slides in cleanly from the left */
    <section className="mig-home-hero-section">
      {/* Hero - Figma: node I437:1203;437:1189, full viewport height.
          The entire box + heading slides in from the left together. The
          background is a looping video served from the website module's
          assets bucket; #C6C7C9 stays as a poster fallback before the
          video buffers. */}
      <div className="hero-container" data-visible={visible}>
        <video
          autoPlay
          loop
          muted
          playsInline
          aria-hidden="true"
          className="mig-home-hero-video"
        >
          <source src="/assets/modules/website/videos/intro-painters-may-20-final-1080.webm" type="video/webm" />
        </video>
        {/* Figma: Heading/h1-hero - alfarn-2, 80px, weight 700, lineHeight 1 */}
        <h1 className="mig-hero-heading">
          We move art<br />
          beyond traditional<br />
          galleries into<br />
          everyday life<br />
          to be discovered<br />
          and bought
        </h1>
      </div>
    </section>
  )
}
